<template>
  <v-container :fluid="true" class="bg-light-beige ma-0 pa-0">
    <div class="page__container">
      <div class="page__title">
        Повторная отправка письма
      </div>
      <div class="page__subtitle" v-if="type === 'registration'">
        Вы уже начали процесс регистрации с данной электронной почтой.
        <br>Чтобы завершить регистрацию, пожалуйста, проверьте свою почту и, следуя инструкциям в письме, подтвердите регистрацию.
        <br>Если вы не получили письмо, проверьте папку «Спам» или «Нежелательная почта».
        <br>Если письмо не было получено или прошло более 3 дней, нажмите кнопку «Повторная отправка письма», и мы отправим вам новое письмо для подтверждения регистрации.
        <br>Пожалуйста, обратите внимание, что если заявка не подтвердится в течение 90 дней с момента ее подачи, она будет автоматически удалена.
        <br>Если у вас возникли проблемы, обратитесь в нашу службу поддержки по адресу <a href="mailto:help@mendeleevskayakarta.ru" class="text-decoration-none" style="color: #376FFE">help@mendeleevskayakarta.ru</a>.
      </div>
      <div class="page__subtitle" v-else-if="type === 'recovery'">
        Восстановление пароля недоступно, ваш аккаунт еще не подтвержден.
        <br>Для завершения процесса регистрации, пожалуйста, проверьте свою почту и следуйте инструкциям в письме, которое было отправлено вам после регистрации.
        <br>Если вы не получили письмо, проверьте папку «Спам» или «Нежелательная почта».
        <br>Если письмо не было получено или прошло больше 3 дней, то нажмите кнопку  «Повторная отправка письма», и мы отправим вам новое письмо для подтверждения регистрации.
        <br>Если ваш аккаунт останется неподтвержденным в течение 90 дней с момента его создания, он будет автоматически удален в соответствии с нашими правилами безопасности.
        <br>Если у вас возникли проблемы, обратитесь в нашу службу поддержки по адресу <a href="mailto:help@mendeleevskayakarta.ru" class="text-decoration-none" style="color: #376FFE">help@mendeleevskayakarta.ru</a>.
      </div>
      <div class="page__subtitle text-center" v-else>
        Нажмите кнопку <b>«Отправить письмо»</b>, <br>и мы отправим вам новое письмо для подтверждения регистрации.
      </div>
      <div class="text_field__container">
        <div v-if="error">
          <v-alert
              v-if="error.error"
              class="error_alert"
              :value="true"
              outline
              :icon="false"
              color="#8f0808"
              variant="outlined"
          >
            {{ error.error }}
          </v-alert>
        </div>
        <div class="btn__next back" @click="endRedirect">
        <span class="btn__next_text">
          На главную
        </span>
        </div>
        <v-btn
            class="btn__next"
            elevation="0"
            :loading="loading"
            :disabled="send_success"
            @click="sendNewMail"
        >
        <span class="btn__next_text">
          <span v-if="countdown_text">{{ countdown_text }}</span>
          <span v-else>Отправить письмо</span>
        </span>
        </v-btn>
      </div>
    </div>
  </v-container>
</template>

<script>
import { defineComponent } from 'vue'
import names from "@/modules/core/routers/names"
import { mapActions, mapGetters } from "vuex"
import { useCookies } from "vue3-cookies"

export default defineComponent({
  name: "RegistrationInfoReSendEmail",
  setup () {
    const { cookies } = useCookies()
    return { cookies }
  },
  data () {
    return {
      loading: false,
      error: null,
      email: null,
      send_success: false,
      countdown_text: null,
      type: null,
    }
  },
  computed: {
    names () {
      return names
    },
    ...mapGetters({
      isAuthenticated: 'auth/isAuthenticated',
    })
  },
  methods: {
    ...mapActions({
      resendApproveEmail: 'personal_account/users/resendApproveEmail'
    }),
    endRedirect () {
      this.$router.push({ name: names.MAIN })
    },
    sendNewMail: function () {
      this.loading = true
      this.error = null
      this.resendApproveEmail(
        {
          data: { email: this.email },
          finalizer: () => {
            this.loading = false
            this.error = null
            this.sendTimeout(true)
          },
          catcher: (error) => {
            this.loading = false
            this.error = error
            if (error.error === 'Запрос повторной отправки письма доступен раз в 10 минут') {
              this.sendTimeout(true)
            }
          }
        }
      )
    },
    sendTimeout (need_start = false) {
      const get_domain = () => {
        // Ваша логика для определения домена
      }

      const sendTimeoutTimer = (time) => {
        setTimeout(() => {
          this.send_success = false
        }, time)
        this.countDownTimer(time)
      }

      if (this.$cookies.isKey('sendtimeout') && !need_start) {
        if (this.$cookies.get('sendtimeout').userEmail === this.email) {
          this.send_success = true
          sendTimeoutTimer(new Date(this.$cookies.get('sendtimeout').sendTimeout) - new Date())
        }
      } else if (need_start) {
        this.send_success = true
        const date = new Date()
        date.setTime(date.getTime() + 10 * 60 * 1000) // Добавляем 10 минут в миллисекундах
        this.$cookies.set(
          'sendtimeout',
          {
            userEmail: this.email,
            sendTimeout: date,
          },
          date,
          null,
          get_domain(),
          null
        )
        sendTimeoutTimer(600000)
      } else {
        return null
      }
    },
    countDownTimer (time) {
      const interval = setInterval(() => {
        if (time <= 0) {
          this.countdown_text = null
          clearInterval(interval)
        } else {
          time -= 1000
          const minutes = Math.floor((time / 1000) / 60)
          const seconds = Math.floor((time / 1000) % 60)

          this.countdown_text = `${minutes} мин. ${seconds} сек.`
        }
      }, 1000)
    }
  },
  created () {
    if (this.$route.query.email && !this.isAuthenticated) {
      if (this.$route.query.type) {
        this.type = this.$route.query.type
      }
      this.email = this.$route.query.email
      this.sendTimeout()
    } else {
      this.endRedirect()
    }
  },
})
</script>

<style scoped lang="scss">
.page__container {
  width: 100%;
  max-width: 1280px;
  margin: 150px auto;
  padding-bottom: 150px;
}

.page__title {
  margin-top: 30px;
  margin-bottom: 30px;
  font-style: normal;
  font-weight: 800;
  font-size: 75px;
  line-height: 84px;
  text-align: center;

  color: #3254B9;
}

.page__subtitle {
  margin-bottom: 50px;
  font-style: normal;
  font-weight: 600;
  font-size: 30px;
  line-height: 45px;
  text-align: justify;

  color: #313743;
}

.btn__next {
  cursor: pointer;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  align-self: end;
  margin-bottom: 40px;
  width: 360px;
  height: 80px;
  border: 2px solid #3254B9;
  background-color: #3254B9;
  border-radius: 10px;

  &.back {
    width: 240px;
    margin-right: 50px;
    background-color: transparent;

    .btn__next_text {
      color: #3254B9;
    }

    &:hover {
      background-color: #3254B9;

      .btn__next_text {
        color: #FFFFFF;
      }
    }
  }

  &:hover {
    background-color: transparent;

    .btn__next_text {
      color: #3254B9;
    }
  }
}

.btn__next_text {
  font-style: normal;
  font-weight: 700;
  font-size: 24px;
  line-height: 29px;
  letter-spacing: 0.05em;
  text-transform: uppercase;
  color: #FFFFFF;
}

.text_field__container {
  margin: 0 auto;
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  width: 800px;
}

.error_alert {
  border-radius: 10px;
  font-style: normal;
  font-weight: 700;
  font-size: 20px;
  line-height: normal;
  color: #8f0808;
  margin-bottom: 20px;
}

@media screen and (max-width: 1920px) {
  .page__title {
    font-size: 65px;
    line-height: 74px;
  }

  .page__subtitle {
    margin-bottom: 40px;
    font-size: 25px;
    line-height: 35px;
  }

  .text__field {
    margin-bottom: 10px;
  }

  .btn__next {
    height: 70px;
  }
}

@media screen and (max-width: 1279px) {
  .page__title {
    font-size: 50px;
    line-height: 57px;
    padding: 0 40px;
  }

  .page__subtitle {
    font-size: 20px;
    line-height: 25px;
    padding: 0 40px;
  }

  .text_field__container {
    width: 600px;
  }

  .btn__next {
    margin: 0 30px 30px;

    &.back {
      width: 360px;
      margin-right: 30px;
    }
  }
}

@media screen and (max-width: 768px) {
  .page__title {
    font-size: 30px;
    line-height: 37px;
    padding: 0 20px;
  }

  .page__subtitle {
    margin-bottom: 40px;
    font-size: 18px;
    line-height: 22px;
    padding: 0 20px;
  }

  .btn__next {
    width: 240px;
    margin: 0 10px 20px;
    height: 55px;

    &.back {
      width: 240px;
      margin-right: 10px;
    }
  }

  .btn__next_text {
    font-size: 16px;
    line-height: 20px;
  }

  .text_field__container {
    width: 400px;
  }
}

@media screen and (max-width: 600px) {
  .text_field__container {
    width: 360px;
  }
}

@media screen and (max-width: 400px) {
  .text_field__container {
    width: 270px;
  }
}
</style>
